import type { ReactNode } from "react";
import cx from "ui/cx";
import InputGridLabel from "ui/forms/InputGridLabel";
import type { InputGridLabelProps } from "ui/forms/InputGridLabel";
import styles from "./InputGridGroup.module.scss";

export interface InputGridGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  label: InputGridLabelProps;
  children: ReactNode;
}

export default function InputGridGroup({ label, children, className, ...props }: InputGridGroupProps) {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      <InputGridLabel {...label} />
      <div className={styles.input}>{children}</div>
    </div>
  );
}
